module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card-title', [_c('h3', [_vm._v("Plan data")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.planData.name) + "\n      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Price")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.quotationTotalPrice)) + "\n      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake Dates")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.moment(_vm.caseData.wake_start).format('YYYY-MM-DD')) + " - " + _vm._s(_vm.caseData.wake_end ? _vm.moment(_vm.caseData.wake_end).format('YYYY-MM-DD') : 'not set') + "\n        ")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497da100","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CasePlanDataTable.vue
// module id = 958
// module chunks = 1